import React from 'react';

import { RCTextWithIcon } from '@reverbdotcom/cadence/components';
import CouponIcon from '@reverbdotcom/cadence/images/nudge/coupon.svg?component';

interface IExternalProps {
  headerText: string;
  children: React.ReactNode;
}

export function ShopCampaignCouponPreview({ headerText, children }: IExternalProps) {
  return (
    <div className="shop-campaign-coupon-preview">
      <div className="shop-campaign-coupon-preview__header">
        <RCTextWithIcon svgComponent={CouponIcon} placement="left">
          {headerText}
        </RCTextWithIcon>
      </div>
      <div className="shop-campaign-coupon-preview__body">
        {children}
      </div>
    </div>
  );
}

export default ShopCampaignCouponPreview;
